import React from 'react'

function SocialLink({ title, name, href, openInSameTab, analyticsActionText }) {
  const socialLinkProps = {
    href,
    className: `share-component__btn share-component__btn--${name}`,
    title: title,
    rel: 'noopener noreferrer',
    key: name,
    'data-type': name,
    'data-analytics-action-text': analyticsActionText,
  }

  if (!openInSameTab) {
    socialLinkProps.target = '_blank'
  }

  return <a {...socialLinkProps} />
}

function SocialButton({ title, name, onClick, analyticsActionText }) {
  const socialbuttonProps = {
    onClick,
    className: `share-component__btn share-component__btn--${name}`,
    title: title,
    type: 'button',
    key: name,
    'data-type': name,
    'data-analytics-action-text': analyticsActionText,
  }
  return <button {...socialbuttonProps} />
}

export function SocialButtonOrLink(props) {
  return props.href ? SocialLink(props) : SocialButton(props)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/social_buttons/components/SocialButton.view.js